module.exports = __webpack_public_path__ + "img/3-01.7c2c5749.png";